import './registerPro.css';

import FormRegister from '../../../Component/form_register/formRegister';

function RegisterPro() {
    return (
      <div className='resgister_page'>
        <FormRegister title="Inscription professionnelle" isPro={true} />
      </div>
    );
}

export default RegisterPro;